import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const CheckboxWrapper = styled(Box)`
  display: flex;
  margin-top: 20px;
  margin-left: 10px;
  align-items: flex-start;
`;
